import React from 'react'
import ReactDOM from 'react-dom'
import {get, noop, isEqual} from 'lodash'
import {NavContent} from 'primary-navbar!sofe'
import {CprButton} from 'canopy-styleguide!sofe'
import PropTypes from 'prop-types'
import singleSpaReact from 'single-spa-react'
import {Scoped, a} from 'kremling'

export default class ReauthenticationDrawer extends React.Component {
  static propTypes = {
    emailAccount: PropTypes.object,
    emailAccounts: PropTypes.array,
    setupPulser: PropTypes.func,
    wasDismissed: PropTypes.func,
    dismissOnNavigate: PropTypes.bool,
  }
  static defaultProps = {
    setupPulser: noop,
    wasDismissed: noop,
    drawerStyles: {},
  }
  state = {
    existingReauthenticationDrawer: document.getElementById('email-account-reauthentication-drawer'),
    dismissed: false,
    pulse: false,
  }
  componentDidMount() {
    const pulser = {
      pulse: () => {
        if (this.unmounted) {
          return
        }

        if (this.state.existingReauthenticationDrawer) {
          this.state.existingReauthenticationDrawer?.pulse?.()
        } else {
          this.setState(prevState => {
            return prevState.dismissed ? {dismissed: false} : {pulse: true}
          }, () => {
            setTimeout(() => {
              if (!this.unmounted) {
                this.setState(prevState => {
                  return prevState.pulse ? {pulse: false} : null
                })
              }
            }, 250)
          })
        }
      }
    }

    if (this.el) {
      this.el.pulse = pulser.pulse
    }

    this.props.setupPulser(pulser)

    if (this.state.existingReauthenticationDrawer) {
      this.state.existingReauthenticationDrawer?.pulse?.()
    }

    if (this.props.dismissOnNavigate) {
      window.addEventListener('single-spa:routing-event', this.dismissDrawer)
    }
  }
  render() {
    const emailAccounts = this.props.emailAccounts || [this.props.emailAccount]
    const accountsToReauthenticate = emailAccounts.filter(isReauthenticationRequired)
    const multipleBadAccounts = accountsToReauthenticate.length > 1

    if (accountsToReauthenticate.length === 0 || this.state.existingReauthenticationDrawer) {
      return null
    }

    return (
      <Scoped css={css}>
        <div className={a('drawer').t('out', 'in', this.state.dismissed).m('pulse', this.state.pulse)} id="email-account-reauthentication-drawer" ref={el => this.el = el} style={this.props.drawerStyles}>
          <NavContent hasTopnavSecondary={false} contactMenuPossible={false} style={{marginLeft: 0, width: 'auto', padding: 0}}>
            <div className="cps-card__height-3 card">
              <img src="https://cdn.canopytax.com/images/Disconnect_Icon.svg" className="image" />
              <div className="copy cps-gray cps-body">
                Your account{multipleBadAccounts ? 's' : ''} {this.accountNames(accountsToReauthenticate)} {multipleBadAccounts ? 'have' : 'has'} been disconnected.
                You'll need to reauthenticate in account settings.
                <a className="cps-icon cps-icon-close" onClick={this.dismissDrawer} />
              </div>
              <a href={`#/communications/global-settings/email${multipleBadAccounts ? '' : '/' + accountsToReauthenticate[0].id}`}>
                <CprButton actionType="primary">
                  Go to Account Settings
                </CprButton>
              </a>
            </div>
          </NavContent>
        </div>
      </Scoped>
    )
  }
  componentDidUpdate(prevProps) {
    if (get(prevProps, 'emailAccount.id') !== get(this.props, 'emailAccount.id') || !isEqual(prevProps.emailAccounts, this.props.emailAccounts)) {
      this.setState({dismissed: false, pulse: false})
    }
  }
  componentWillUnmount() {
    this.unmounted = true
    window.removeEventListener('single-spa:routing-event', this.dismissDrawer)
  }
  dismissDrawer = () => {
    this.setState({dismissed: true}, () => {
      this.props.wasDismissed()
    })
  }
  accountNames = emailAccounts => {
    return emailAccounts.map((account, index) => {
      let prefix
      if (index === 0) {
        prefix = ''
      } else if (index === emailAccounts.length - 1) {
        prefix = ' and '
      } else {
        prefix = ', '
      }

      return (
        <span key={account.id}>
          {prefix}<span className="email-address">{account.email}</span>
        </span>
      )
    })
  }
}

export const isReauthenticationRequired = (account) => (
  account && account.connectionStatus === "reauthenticationRequired"
);

export const reauthenticationDrawerParcel = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: ReauthenticationDrawer,
})

const css = `
  & .cps-icon-close {
    position: absolute;
    right: 16px;
    top: 16px;
    padding: 4px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color: 250ms;
    text-decoration: none;
  }

  & .cps-icon-close:hover {
    background-color: #e9e9e9;
  }

  & .email-address {
    font-weight: bold;
    font-style: italic;
  }

  & .card {
    width: 400px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    pointer-events: all;
    position: relative;
    transition: all .25s;
  }

  & .card > * {
    width: 100%;
  }

  & .pulse .card {
    transform: scale(1.1);
  }

  & .image {
    height: 48px;
  }

  & .image, & .copy {
    margin-bottom: 16px;
  }

  & .drawer {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 999;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    padding-right: 40px;
    pointer-events: none;
  }

  & .in {
    animation-duration: 0.5s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
    transform: translateX(500px);
    animation-name: slideIn;
  }

  & .out {
    animation-duration: 0.5s;
    animation-timing-function: ease-in;
    animation-fill-mode: forwards;
    animation-name: slideOut;
    transform: translateX(0px);
  }

  @keyframes slideIn {
    0% {
      transform: translateX(500px);
    }
    100% {
      transform: translateX(0px);
    }
  }

  @keyframes slideOut {
    0% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(500px);
    }
  }
`
